import { render, staticRenderFns } from "./m-modal.vue?vue&type=template&id=0c7f87c0&scoped=true"
import script from "./m-modal.vue?vue&type=script&lang=js"
export * from "./m-modal.vue?vue&type=script&lang=js"
import style0 from "./m-modal.vue?vue&type=style&index=0&id=0c7f87c0&prod&scoped=true&lang=scss"
import style1 from "./m-modal.vue?vue&type=style&index=1&id=0c7f87c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7f87c0",
  null
  
)

export default component.exports